import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { getUser } from '../../redux/user/actions';
import { getLockedDashboardTimeRange } from '../../utils/user/dashboardTimeRange';

import IntervalSelector from './intervalSelector';
import CustomTag from '../customTag';
import Calendar from '../calendar/calendar';
import CustomDateInput from '../customDateInput';
import calendarUtils from '../../utils/calendar';

import './styles.scss';

const DateTimeFilterBar = ({
  appliedFilters={},
  onPeriodSelected,
  hideIntervalSelector
}) => {
  const [filters, setFilters] = useState([]);
  const [startTime, setStartTime] = useState('');
  const [endTime, setEndTime] = useState('');
  const [weekDays, setWeekDays] = useState([]);
  const lockedRange = getLockedDashboardTimeRange(useSelector(getUser)?.preferences);

  const formatTime = time => {
    const formatedTime = time.split(':');
    return `${formatedTime[0]}:${formatedTime[1]}`;
  };

  const storeFilters = ({ filterByTime, filterByWeekday }) => {
    const availableFilters = [];

    if (filterByTime) {
      const startTime = formatTime(filterByTime.start);
      const endTime = formatTime(filterByTime.end);
      const filterText = `${startTime} to ${endTime}`;
      setStartTime(startTime);
      setEndTime(endTime);
      availableFilters.push({ type: 'time', text: filterText });
    }

    if (filterByWeekday) {
      const days = filterByWeekday.map(day => day.id).join(', ');
      const filterText = `Only ${days}`;
      setWeekDays(filterByWeekday);
      availableFilters.push({ type: 'day', text: filterText });
    }

    setFilters(availableFilters);
  };

  const removeFilter = (index, filterType) => {
    const currentFilters = [...filters];

    currentFilters.splice(index, 1);
    setFilters(currentFilters);

    if (filterType === 'day') {
      setWeekDays([]);
      onPeriodSelected({ filterByWeekday: [] });
    } else if (filterType === 'time') {
      setStartTime('');
      setEndTime('');
      onPeriodSelected({ filterByTime: {} });
    }
  };

  const onSelect = data => {
    storeFilters(data);

    // Get only the week day numbers to send to Query API. Empty values are
    // explicit so disabling a calendar filter also refreshes its consumers.
    onPeriodSelected({
      ...data,
      filterByTime: data.filterByTime || {},
      filterByWeekday: data.filterByWeekday ? data.filterByWeekday.map(day => day.value) : []
    });
  };

  return (
    <div className="date-time-filter-bar">
      {lockedRange ? (
        <div className="period-selector">
          <CustomDateInput
            startDate={new Date(`${lockedRange.startDate.slice(0, 10)}T12:00:00`)}
            endDate={new Date(`${lockedRange.endDate.slice(0, 10)}T12:00:00`)}
            readOnly
          />
        </div>
      ) : <Calendar
        onSelect={onSelect}
        startDate={appliedFilters.startDate}
        endDate={appliedFilters.endDate}
        startTime={startTime}
        endTime={endTime}
        weekDays={weekDays}
      />}
      {!hideIntervalSelector && (
        <IntervalSelector
          intervalSelected={appliedFilters.interval}
          onIntervalSelected={interval => {
            onPeriodSelected({interval: calendarUtils.getIntervalById(interval)})
          }} />
      )}
      <div className="period-selector-filters">
        {filters.map((filter, index) => (
          <CustomTag key={index} value={filter.text} onClose={() => removeFilter(index, filter.type)} />
        ))}
      </div>
    </div>
  );
};

export default DateTimeFilterBar;
